module.exports = __webpack_public_path__ + "img/vpc.09f53e4.svg";